import { utils } from '@hh/global.js'
const { addToCart, reRenderShopifySections, fetchCart, updateCart } = utils

class FreebiePromos extends HTMLElement {
  constructor() {
    super()

    this.handleProductAdded = this.handleProductAdded.bind(this)
    this.handleCartQuantityUpdated = this.handleCartQuantityUpdated.bind(this)
  }

  async connectedCallback() {
    this.promotions =
      JSON.parse(this.querySelector('[data-promo-data]').textContent) || []

    document.addEventListener('productAdded', this.handleProductAdded)
    document.addEventListener(
      'cartQuantityUpdated',
      this.handleCartQuantityUpdated
    )

    this.addPromoItemsIfEligible()
  }

  disconnectedCallback() {
    document.removeEventListener('productAdded', this.handleProductAdded)
    document.removeEventListener(
      'cartQuantityUpdated',
      this.handleCartQuantityUpdated
    )
  }

  handleProductAdded() {
    this.addPromoItemsIfEligible()
  }

  async handleCartQuantityUpdated(event) {
    const cart = event.detail.cart
    if (cart) {
      const applicablePromo = this.promotions.find((promo) =>
        cart.discount_codes.find((discount) =>
          discount.code.startsWith(promo.couponPrefix)
        )
      )

      if (applicablePromo) {
        const nonFreebieItems = cart.items.filter(
          (cartItem) => !applicablePromo.items.includes(cartItem.variant_id)
        )
        const freebieItems = cart.items.filter((cartItem) =>
          applicablePromo.items.includes(cartItem.variant_id)
        )

        if (freebieItems.length && !nonFreebieItems.length) {
          const updates = {}
          freebieItems.forEach((cartItem) => {
            updates[cartItem.key] = 0
          })

          reRenderShopifySections(await updateCart({ updates: updates }))
        }
      }
    }
  }

  async addPromoItemsIfEligible() {
    try {
      const cart = await fetchCart()

      const applicablePromo = this.promotions.find((promo) =>
        cart.discount_codes.find((discount) =>
          discount.code.startsWith(promo.couponPrefix)
        )
      )

      // Only add promo items that aren't currently in the cart
      const promoItemsToAdd =
        applicablePromo?.items.filter(
          (variantId) =>
            cart.items.length &&
            !cart.items.find((cartItem) => cartItem.variant_id === variantId)
        ) ?? []

      if (!promoItemsToAdd.length) return

      const payload = {
        items: promoItemsToAdd.map((variantId) => ({
          id: variantId,
          quantity: 1,
        })),
      }

      reRenderShopifySections(
        await addToCart(payload, `mini-cart,header,inline-cart`)
      )
    } catch (e) {
      console.error(e)
    }
  }
}

customElements.define('freebie-promos', FreebiePromos)
